const getQueryKey = (sellerOrderId: string, fileVariant: string) => [
  'sellerOrderId',
  'fileVariant',
  'deletionList',
  sellerOrderId,
  fileVariant,
];

export default getQueryKey;
